export const timelineAnalysisMock = {
    factors: [
        {
            key: 'predominantSentiment',
            value: '😀 Satisfeito',
            count: 5,
            percentage: 60,
            evidence: [
                { id: '1', label: '16/08', satisfaction: '😀' },
                { id: '3', label: '01/08', satisfaction: '😀' },
                { id: '4', label: '15/08', satisfaction: '😀' },
            ],
        },
        {
            key: 'estimatedSatisfaction',
            value: '59/100',
            count: 2,
            evidence: [
                { id: '2', label: '23/08', satisfaction: '😐' },
                { id: '4', label: '15/08', satisfaction: '😀' },
            ],
        },
        {
            key: 'trend',
            value: 'Estável',
            trend: 'stable',
            evidence: [
                { id: '1', label: '16/08', satisfaction: '😀' },
                { id: '2', label: '23/08', satisfaction: '😐' },
            ],
        },
    ],
};
